// Site-wide constants and mock content used across the clone.
// The hero uses the exact attached image so it is 100% identical to the source.

export const HERO_IMAGE =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_47d91712-297c-4276-823b-57d4d7ee645c/artifacts/05hq3i1z_B9014735-FA05-4817-8E9B-847E09550751.png";

// Desktop hero uses a locally cleaned copy (removes a faint gold speck near the
// bottom-right of the "G" in "We Grow It."). Logo/mobile keep the original.
export const HERO_DESKTOP = `${process.env.PUBLIC_URL || ""}/hero-desktop.png`;

// Black & white London skyline used only for the mobile hero image.
export const HERO_MOBILE_SKYLINE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_design-replica-249/artifacts/j9qq09w8_IMG_3173.jpeg";

// Brand palette sampled from the attached image
export const COLORS = {
  navy: "#0a1f3d",
  navyDeep: "#081831",
  gold: "#e9a31e",
  goldLight: "#f2b743",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Packages", to: "/packages" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT = {
  phone: "07448 671 884",
  phoneRaw: "447448671884",
  email: "info@onlineofficesolutions.co",
  whatsapp: "https://wa.me/447448671884",
};

// Case study imagery + external links
export const CASE_IMAGES = {
  soho: "https://customer-assets-eiarnc6j.emergentagent.net/wingman/1b579b6a-2d4e-44eb-97e9-b3d7a8a3bfc9/attachments/856156b183364c558c39854e8d667fff_image.jpeg",
  mkc: "https://customer-assets-eiarnc6j.emergentagent.net/wingman/1b579b6a-2d4e-44eb-97e9-b3d7a8a3bfc9/attachments/a4dcb005566146fab31c0c0b43360b86_ab63da5b-f670-4980-b7a0-478d936c5692.jpeg",
};

export const CASE_LINKS = {
  soho: "https://soho69tfs.com",
  mkc: "https://mobilekitchencompany.uk/",
};
